/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { formatKahuMessages } from '@/utils/formatKahuMessages';

import { cn } from '@/lib/utils';

type KahuUserPromptProps = {
  message: React.ReactNode;
  className?: string;
};

export const KahuUserPrompt = ({ message, className }: KahuUserPromptProps) => {
  const formattedMessage =
    typeof message === 'string' ? formatKahuMessages(message) : message;

  return (
    <div className="flex justify-end [contain-intrinsic-size:auto_80px] [content-visibility:auto]">
      <div
        className={cn(
          'relative w-fit rounded-lg rounded-br-none bg-[#166F6B] py-2 pl-3 pr-4',
          className
        )}
      >
        <p className="text-body font-normal text-body-secondary">
          {formattedMessage}
        </p>
        <span className="absolute bottom-0 left-full h-2 w-[6px] bg-[#166F6B] [clip-path:polygon(0_0,_100%_100%,_0_100%)]"></span>
      </div>
    </div>
  );
};
